import styled, { keyframes } from 'styled-components'
import { hexToRgba } from '../../utils'

const getBackgroundColor = ({ theme, primary, opacity = 1 }) => {
  const bgColor = primary ? theme.colors.primary : theme.palette.white
  return hexToRgba(bgColor, opacity)
}

const get2ndDotSpacing = ({ large }) => {
  return large ? `24px` : `16px`
}
const get3rdDotSpacing = ({ large }) => {
  return large ? `48px` : `32px`
}

const typing = props => {
  return keyframes`
        0%{
            background-color: ${getBackgroundColor(props)};
            box-shadow: ${get2ndDotSpacing(props)} 0px 0px 0px ${getBackgroundColor({ ...props, opacity: 0.2 })},
            ${get3rdDotSpacing(props)} 0px 0px 0px ${getBackgroundColor({ ...props, opacity: 0.2 })};
        }
        25%{
            background-color: ${getBackgroundColor({ ...props, opacity: 0.4 })};
            box-shadow: ${get2ndDotSpacing(props)} 0px 0px 0px ${getBackgroundColor(props)},
            ${get3rdDotSpacing(props)} 0px 0px 0px ${getBackgroundColor({ ...props, opacity: 0.2 })};
        }
        75%{
            background-color: ${getBackgroundColor({ ...props, opacity: 0.4 })};
            box-shadow: ${get2ndDotSpacing(props)} 0px 0px 0px ${getBackgroundColor({ ...props, opacity: 0.2 })},
            ${get3rdDotSpacing(props)} 0px 0px 0px ${getBackgroundColor(props)};
        }
        `
}

const DotLoader = styled.span`
  display: inline-block;
  width: ${props => (props.large ? `12px` : `8px`)};
  height: ${props => (props.large ? `12px` : `8px`)};
  border-radius: 50%;
  -webkit-animation: ${typing} 1s linear infinite alternate;
  -moz-animation: ${typing} 1s linear infinite alternate;
  animation: ${typing} 1s linear infinite alternate;
  position: relative;
  left: -${get2ndDotSpacing};
`

export default DotLoader
